import { Box, Button } from '@mui/material';

import { useTranslate } from 'src/locales';

import { useChannelContext } from '../hooks';

type RenderPrevNextBtnProps = {
  isNextDisabled?: boolean;
};

export const RenderPrevNextBtn = ({ isNextDisabled }: RenderPrevNextBtnProps) => {
  const { t } = useTranslate('translation');
  const { onChangeStep } = useChannelContext();

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        justifyContent: 'flex-end',
        alignItems: 'center',
      }}
    >
      <Box>
        <Button variant="outlined" color="inherit" onClick={() => onChangeStep('back')}>
          {t('PREVIOUS')}
        </Button>
      </Box>
      <Box>
        <Button
          disabled={isNextDisabled}
          size="small"
          variant="contained"
          type="submit"
          onClick={() => onChangeStep('next')}
        >
          {t('NEXT')}
        </Button>
      </Box>
    </Box>
  );
};
